'use client';
import React from 'react';
import AppLayout from '@/components/AppLayout';
import CurriculumLibrariesContent from './components/CurriculumLibrariesContent';

export default function CurriculumLibrariesPage() {
  return (
    <AppLayout role="professional" campusMode="pro">
      <CurriculumLibrariesContent />
    </AppLayout>
  );
}
